<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="满减说明:" label-width='150px'>
            <el-input v-model="submit_data.title" :placeholder="submit_rules.title.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>






          <el-form-item label="状态:" label-width='150px'>
            <el-select v-model="value_status_code" placeholder="请选择状态" style="width: 150px; margin-right: 20px;"
              @change="statusChange" clearable>
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>



          <el-form-item label="满足条件（天）:" label-width='150px'>
            <div>
              <el-button class="el-icon-minus" style="padding: 5px;" @click="btn('full_day','-')"></el-button>
              <el-input v-model="submit_data.full_day" :placeholder="submit_rules.full_day.placeholder"
                style="width: 80px;">
              </el-input>
              <el-button class="el-icon-plus" style="padding: 5px;" @click="btn('full_day','+')"></el-button>
            </div>
          </el-form-item>


          <el-form-item label="减少金额（元）:" label-width='150px'>
            <div>
              <el-button class="el-icon-minus" style="padding: 5px;" @click="btn('sub_amount','-')"></el-button>
              <el-input v-model="submit_data.sub_amount" :placeholder="submit_rules.sub_amount.placeholder"
                style="width: 80px;">
              </el-input>
              <el-button class="el-icon-plus" style="padding: 5px;" @click="btn('sub_amount','+')"></el-button>
            </div>
          </el-form-item>

          <el-form-item label="预存保险费（单）:" label-width='150px'>
            <div>
              <el-button class="el-icon-minus" style="padding: 5px;" @click="btn('insurance_num','-')"></el-button>
              <el-input v-model="submit_data.insurance_num" :placeholder="submit_rules.insurance_num.placeholder"
                        style="width: 80px;">
              </el-input>
              <el-button class="el-icon-plus" style="padding: 5px;" @click="btn('insurance_num','+')"></el-button>
            </div>
          </el-form-item>

        </el-form>


        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center">
          <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="false"></submitBtn>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>


    </div>




  </el-drawer>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

      },
    },
    data() {
      return {


        show: false,

        value_status_code: '',



        submit_url:'/driver/addSigningPreferentialSubmit',


        // 表单数据
        submit_data: {
          title: '',
          full_day: 0,
          sub_amount: 0,
          status: '',
          insurance_num:0
        },

        submit_rules: {
          title: {
            placeholder: '请输入满减说明',
            rules: {
              required: true,
              message: '满减说明长度3个文字以上',
              regulation: 'gt_str',
              rulesData: 3
            }
          },
          full_day: {
            placeholder: '请输入满足条件（天）',
            rules: {
              required: true,
              message: '满足条件（天）不能小于0',
              regulation: 'egt',
              rulesData: 0
            }
          },
          sub_amount: {
            placeholder: '请输入减少金额（元）',
            rules: {
              required: true,
              message: '减少金额（元）不能小于0',
              regulation: 'egt',
              rulesData: 0
            }
          },
          insurance_num: {
            placeholder: '请输入预存保险费（单）',
            rules: {
              required: true,
              message: '预存保险费（单）',
              regulation: 'egt',
              rulesData: 0
            }
          },
          status: {
            placeholder: '状态',
            rules: {
              required: true,
              message: '状态',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      btn(val, algorithm) {

        if (val == 'full_day') {

          if (algorithm == '+') {

            _this.submit_data.full_day++;

          } else if (algorithm == '-') {

            if (_this.submit_data.full_day > 0) {

              _this.submit_data.full_day--;

            } else {

              return;

            }

          }
        } else if (val == 'sub_amount') {

          if (algorithm == '+') {

            _this.submit_data.sub_amount++;

          } else if (algorithm == '-') {

            if (_this.submit_data.sub_amount > 0) {

              _this.submit_data.sub_amount--;

            } else {

              return;

            }

          }
        } else if (val == 'insurance_num') {

          if (algorithm == '+') {

            _this.submit_data.insurance_num++;

          } else if (algorithm == '-') {

            if (_this.submit_data.insurance_num > 0) {

              _this.submit_data.insurance_num--;

            } else {

              return;

            }

          }
        }

      },
      statusChange(val) {
        _this.submit_data.status = val;
      },



      // 关闭方法
      closeDialog() {
        _this.show = false;


        _this.submit_data = {
          title: '',
          full_day: 0,
          sub_amount: 0,
          status: '',
          insurance_num:0
        };


        _this.value_status_code = '';

      },

      // 提交
      onSubmitDig() {


            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();

      },


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>